/* 
 * This is a formatted table used to display details
 */
/* global customElements */

import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {BaseComponent} from '../basecomponent.js';

class DetailTable extends BaseComponent {
	
	static get properties() {
		return {
			data: {type: Object}
		};
	}

	constructor() {
		super();
		this.data = [];		
		
		var detailTable = this;
		setTimeout(function(){
			detailTable.init();
		});
	}
	
	render() {	
		return html`			
			<slot></slot>
		`;
	}
	
	init() {		
	}
	
	updateDetails(displayRecords) {
		var detailTable = this;
		
		setTimeout(function(){
			if (detailTable.actualTable) {
				detailTable.actualTable.remove();
			}
			
			detailTable.actualTable = ElementUtil.create({
				tag: 'table',
				'class': 'detail-table',
				style: detailTable.style.cssText
			});

			//add classes from wrapper
			for (var i=0; i<detailTable.classList.length; i++) {
				detailTable.actualTable.classList.add(detailTable.classList.item[i]);
			}

			var templates = [];
			displayRecords.forEach(function(record){
				if (record.section) {
					templates.push(
						'<tr>' +
							'<td style="text-align: center;" class="detail-section" colspan=2>' + record.key + '</td>' +
						'</tr>'
					);		
				} else {
					templates.push(
						'<tr>' +
							'<td><b>' + record.key + '</b></td>' +
							'<td>' + record.value + '</td>' +
						'</tr>'
					);
				}
			});			
			detailTable.actualTable.innerHTML = templates.join('');	
			detailTable.append(detailTable.actualTable);
			
		}, 10);
	} 
	
};
customElements.define('dl-detail-table', DetailTable);

